import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'src/translations/i18n';

import { withStyles, Grid } from '@material-ui/core';
import dayjs from 'dayjs';

import classNames from 'classnames';
import TimePicker from 'src/components/Inputs/CaPicker/TimePicker';
import FormControlLabel from '../../Form/FormControlLabel';

const styles = () => ({
  inputContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  errorField: {
    '& input': {
      borderColor: '#a94442!important'
    }
  },
  errorText: {
    color: '#a94442'
  }
});

function FormTimePicker({
  label, onChange, value, classes, mouseInKey, isRequired, id, disabled,
  minuteStep, allowClear, format, placeholder, isValid, errorText, style, className, disabledTime
}) {
  return (
    <Grid item xs="auto" className={classNames(classes.inputContainer, className)} id={id} style={style}>
      {(label || (!isValid && errorText)) && (
      <Grid container spacing={2} justifyContent="space-between" wrap="nowrap">
        {label && (
        <Grid item>
          <FormControlLabel
              title={I18n.t(label)}
              mouseInKey={mouseInKey}
              isRequired={isRequired}
              isValid={isValid}
            />
        </Grid>
        )}
        {!isValid && errorText && (
        <Grid item>
          <span className={classes.errorText}>{errorText}</span>
        </Grid>
        )}
      </Grid>
      )}
      <TimePicker
        className={!isValid ? classes.errorField : ''}
        allowClear={allowClear}
        value={value}
        onChange={onChange}
        format={format}
        minuteStep={minuteStep}
        disabled={disabled}
        placeholder={placeholder}
        disabledTime={disabledTime}
      />
    </Grid>
  );
}

FormTimePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  style: PropTypes.object,
  label: PropTypes.string,
  mouseInKey: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  errorText: PropTypes.string,
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  minuteStep: PropTypes.number,
  allowClear: PropTypes.bool,
  disabledTime: PropTypes.func
};

FormTimePicker.defaultProps = {
  label: '',
  id: '',
  placeholder: '',
  format: 'HH:mm',
  value: dayjs(),
  mouseInKey: '',
  className: '',
  errorText: '',
  isRequired: false,
  allowClear: false,
  isValid: true,
  disabled: false,
  minuteStep: 30,
  style: {},
  disabledTime: undefined
};

export default withStyles(styles)(FormTimePicker);
